var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { FormMode } from '../../shared/constants';
import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';
import { ORGANISATION_ROLES } from '@careapp/core';
var AdminOrganisationComponent = /** @class */ (function () {
    function AdminOrganisationComponent(route, router, store) {
        var _this = this;
        this.route = route;
        this.router = router;
        this.store = store;
        this.roles = ORGANISATION_ROLES;
        this.formMode = FormMode.EDIT;
        this.category = new FormControl('', Validators.required);
        this.subs = new Array();
        this.organisation = this.store.select(selectors.getSelected(selectors.ORGANISATIONS));
        this.subs.push(this.route.params.subscribe(function (params) { return _this.setOrganisation(params); }));
        this.loading = this.store.select(selectors.invite.getLoading);
        this.sent = this.store.select(selectors.invite.getSent);
        this.error = this.store.select(selectors.invite.getError);
        this.categories$ = this.store.select(selectors.getCurrentOrganisationCategories);
        this.allCategories$ = this.store.select(selectors.getAll(selectors.MEMO_CATEGORIES));
    }
    AdminOrganisationComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this.subs; _i < _a.length; _i++) {
            var sub = _a[_i];
            sub.unsubscribe();
        }
    };
    AdminOrganisationComponent.prototype.setOrganisation = function (params) {
        this.orgId = params.id;
        this.store.dispatch(new actions.RequestInvitationResetAction());
        this.store.dispatch(actions.Organisations.SelectByIdAction({ id: params.id }));
        this.store.dispatch(actions.Organisations.RequestByIdAction({ id: params.id }));
        this.store.dispatch(actions.MemoCategories.RequestAllAction);
        this.store.dispatch(actions.MemoCategories.RequestByIdAction({ id: params.id }));
    };
    AdminOrganisationComponent.prototype.saveOrganisation = function (data) {
        this.store.dispatch(actions.Organisations.RequestSaveAction({ id: this.orgId, data: data }));
    };
    AdminOrganisationComponent.prototype.invite = function (payload) {
        this.store.dispatch(new actions.RequestInvitationSendAction(payload));
    };
    AdminOrganisationComponent.prototype.resetInvite = function () {
        this.store.dispatch(new actions.RequestInvitationResetAction());
    };
    AdminOrganisationComponent.prototype.removeCategory = function ($event) {
        this.store.dispatch(actions.MemoCategories.RequestRemoveById({ id: $event.id }));
    };
    AdminOrganisationComponent.prototype.renderCategory = function (item) {
        return item ? item.name : '';
    };
    AdminOrganisationComponent.prototype.saveCategory = function (event) {
        this.store.dispatch(actions.MemoCategories.RequestAddById(__assign({}, event.row, { ordinal: event.ordinal })));
    };
    AdminOrganisationComponent.prototype.filterCategory = function (search, item) {
        if (!search || !search.toLowerCase) {
            return true;
        }
        return item.name.toLowerCase().startsWith(search.toLowerCase());
    };
    AdminOrganisationComponent.prototype.addCategory = function () {
        if (this.category.valid) {
            this.store.dispatch(actions.MemoCategories.RequestAddById(this.category.value));
            this.category.reset();
        }
    };
    return AdminOrganisationComponent;
}());
export { AdminOrganisationComponent };
